export enum ETypeLecteur {
    JUXTALINK = "JUXTALINK",
    OLAQIN = "OLAQIN",
		PIRANHA = "PIRANHA",
    SCE = "SCE",
}